import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'learn',
    lazy: async () => ({ Component: (await import('./LearnPage')).LearnPage }),
  },
];
